import { useQuery } from "react-query";
import { getTeams } from "services/team.service";

export default function useTeams() {
  return useQuery("teams", async () => await getTeams());
}
